import { render, staticRenderFns } from "./UserListScreen.vue?vue&type=template&id=af35384a&scoped=true&"
import script from "./UserListScreen.vue?vue&type=script&lang=js&"
export * from "./UserListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af35384a",
  null
  
)

export default component.exports